import React, { useEffect, useState } from "react";
import "../style/home.css";
import Footer from "./footer";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const introTokens = [
  { text: "Hi! ", className: "code-greeting" },
  { text: "I’m ", className: "code-keyword" },
  { text: "Kim", className: "code-variable" },
  { text: ", a ", className: "code-punctuation" },
  { text: "student", className: "code-function" },
  { text: " in ", className: "code-punctuation" },
  { text: "Machine Learning", className: "code-string" },
  { text: " at ", className: "code-punctuation" },
  { text: "KTH", className: "code-number" },
  { text: "...", className: "code-comment" },
];

const introText = introTokens.map(({ text }) => text).join("");

function TypedIntro() {
  const [visibleCharacters, setVisibleCharacters] = useState(0);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      setVisibleCharacters(introText.length);
      return undefined;
    }

    let characterCount = 0;
    let isDeleting = false;
    let timeoutId;

    const updateTyping = () => {
      if (isDeleting) {
        characterCount -= 1;
      } else {
        characterCount += 1;
      }

      setVisibleCharacters(characterCount);

      if (characterCount === introText.length) {
        isDeleting = true;
        timeoutId = window.setTimeout(updateTyping, 1600);
        return;
      }

      if (characterCount === 0) {
        isDeleting = false;
        timeoutId = window.setTimeout(updateTyping, 500);
        return;
      }

      timeoutId = window.setTimeout(updateTyping, isDeleting ? 35 : 70);
    };

    timeoutId = window.setTimeout(updateTyping, 400);
    return () => window.clearTimeout(timeoutId);
  }, []);

  let tokenStart = 0;

  return (
    <div className="home-description1" aria-label={introText}>
      <span aria-hidden="true">
        {introTokens.map(({ text, className }) => {
          const visibleText = text.slice(
            0,
            Math.max(0, visibleCharacters - tokenStart),
          );
          tokenStart += text.length;

          return (
            <span className={className} key={`${className}-${tokenStart}`}>
              {visibleText}
            </span>
          );
        })}
        <span className="typing-cursor" />
      </span>
    </div>
  );
}

export default function Home() {
  return (
    <div className="home-page">
      <div className="home">
        <div className="home-content">
          <div className="home-description">
            <TypedIntro />

            <div className="home-description-group">
              <div className="home-description2">
                <span>//Stockholm, Sweden </span>
              </div>
              <div className="home-description3">
                <span>//Machine Learning Student @ KTH</span>
              </div>
              <div className="home-description4">
                <span>//Data Science • Machine Learning • Full-Stack</span>
              </div>
            </div>

            <div className="buttons">
              <Link to="/design-prototypes" className="rectangle_2">
                <FiArrowRight className="home-button-icon" aria-hidden="true" />
                <span className="rectangle-text_2">View Design Projects</span>
              </Link>
              <Link to="/projects" className="rectangle_1">
                <FiArrowRight className="home-button-icon" aria-hidden="true" />
                <span className="rectangle-text_1">
                  View Technical Projects
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
